<template>
  <AppSection id="languages"
              :title="$getConst.pages.language.dictionary"
              type="page"
              :language="true"
              :languageCode="$route.params.language_code"
              :languageName="$route.params.language_name">
    <form class="my-5 mx-5">
      <b-tabs pills card vertical>
        <b-tab v-for="(page, index) in $t($getConst.pages)" :title="$t(page.label)"
               :disabled="Object.keys($t(page)).length === 1">
          <b-form-group v-for="(content, key) in $t(page)"
                        v-if="key !== 'maintenance_message_'
                        && key !== 'error_message_' && key !== 'label'" label-for="name-input">
           <template v-if="key !== 'email_template_footer' && key !== 'freelancer_email_template_footer'">
             <label>{{content}}</label>
             <b-form-input
               v-model="message[key]"
               id="name-input"
               :placeholder="$t($getConst.pages.scope.enter_name)"
               size="lg"
               required
             ></b-form-input>
           </template>
           <template v-else>
             <label v-if="key === 'email_template_footer'">{{$t($getConst.pages.email_template.email_footer)}}</label>
             <label v-if="key === 'freelancer_email_template_footer'">{{$t($getConst.pages.email_template.freelancer_email_footer)}}</label>
             <vue-editor
               id="footer-input"
               ref="footer"
               :placeholder="message[key]"
               :editorToolbar="toolbarOptions"
               v-model.trim="message[key]"
             >
               <template #toolbar>
                 <div class="ql-toolbar ql-snow">
                   <button disabled class="custom-disabled">{{$t($getConst.pages.email_template_configuration.toolbar_variables)}}: </button>

                   <button
                     v-for="variable in variables"
                     @click="addVariable('footer', variable.value)"
                     type="button"
                     class="w-auto border-right"
                   >
                     {{variable.label}}
                   </button>
                 </div>
               </template>
             </vue-editor>
           </template>
          </b-form-group>
        </b-tab>
        <AppConfirmButtons
          :cancel-text="$getConst.pages.button.cancel_changes"
          :is-loading="isSubmitting"
          @onSubmit="updateDictionary"
          @onCancel="onReset"
        />
      </b-tabs>
    </form>
  </AppSection>
</template>

<script>

  import AppSection from "../../components/common/sections/AppSection";
  import {updateDictionary} from "../../api/translate.api";
  import {getOneLanguageDictionary, i18n, loadDictionaries} from "../../shared/locales/i18n";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";
  import routesNames from "../../shared/constants/router";
  import {VueEditor} from "vue2-editor";


  export default {
    name: "index",
    components: {AppSection, AppConfirmButtons, VueEditor},
    data() {
      return {
        pages: null,
        message: {},
        value: null,
        tabs: null,
        isSubmitting: false,
        toolbarOptions: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'color': ['#000000', '#3c4b64','#002776','#00a0da','#e55353','#80379b','#28a745','#e98300'] }],
          [{ 'background': ['transparent', '#3c4b64','#002776','#00a0da','#e55353','#80379b','#28a745','#e98300'] }],
          ['link']
        ],
        variables: [
          {label: this.$t(this.$getConst.pages.email_template_configuration.actualYear), value: "actualYear"},
          {label: this.$t(this.$getConst.pages.email_template_configuration.scopeId), value: "scopeId"},
          {label: this.$t(this.$getConst.pages.email_template_configuration.languageCode), value: "languageCode"},
          {label: this.$t(this.$getConst.pages.email_template_configuration.templateReference), value: "templateReference"},
          {label: this.$t(this.$getConst.pages.email_template_configuration.messageId), value: "messageId"},
          {label: this.$t(this.$getConst.pages.email_template_configuration.sendDate), value: "sendDate"},
        ]
      }
    },
    created() {
      getOneLanguageDictionary(this.$route.params.language_code).then(
        ()=>{
          this.pages = this.$t(this.$getConst.pages);
          Object.keys(this.pages).forEach(index => {
            Object.keys(this.getTabs(index)).forEach(key => {
              if (key !== 'maintenance_message_' && key !== 'error_message_') {
                this.$set(this.message, key, this.$t(this.getKeys(index, key), this.$route.params.language_code))
              }
            });
          })
        }
      );
    },
    methods: {
      getTabs(index) {
        this.tabs = 'this.$getConst.pages.' + index;
        return eval(this.tabs);
      },
      getKeys(type, key) {
        this.value = 'this.$getConst.pages.' + type + '.' + key;
        return eval(this.value);
      },
      updateDictionary() {
        this.isSubmitting = true;
        updateDictionary(this.$route.params.language_code, this.message).then(
          res => {
            this.isSubmitting = false;
            i18n.setLocaleMessage(this.$route.params.language_code, this.message);
            sessionStorage.setItem(this.$route.params.language_code, JSON.stringify(this.message));
            this.$snotify.success(this.$t(this.$getConst.pages.language.language_updated));
          },
          (error) => {
            this.isSubmitting = false;
            this.handleApiError(error);
          }
        )
      },
      onReset() {
        this.$router.push({name: routesNames.administration.languages});
      },
      addVariable(ref, variable) {
        let quill = this.$refs[ref][0].quill;
        let index = quill.getSelection().index
        quill.insertText(index, "{{"+variable+"}} ");
        quill.setSelection(index + (variable.length + 5))
      }
    }
  }
</script>

<style languaged>
  .save {
    margin-right: 2% !important;
    float: right;
  }
  .nav-link.disabled {
    font-weight: bold;
    color: #000000ad;
    font-size: 16px;
  }
  .custom-disabled {
    width: auto !important;
    pointer-events: none;
    font-weight: bold;
  }
  .ql-editor {
    min-height: 70px !important;
  }
  .btn-inputs {
    transition:  all 1s ease;
  }
</style>
